import { Injectable } from '@angular/core';
import { UserService, UpdateUserPictureRequest, UserInformation, UserProfileUpdateField } from '@bluecrew/crew-member-backend-angular-client';

@Injectable({ providedIn: 'root' })
export class CmosUserClientService {

  constructor(
    private readonly userService: UserService
  ) { }

  getUser(): Promise<UserInformation> {
    return this.userService.getUser().toPromise();
  }

  updateUserPicture(payload: UpdateUserPictureRequest): Promise<UserInformation> {
    return this.userService.updateUserPicture(payload).toPromise();
  }

  updateUserProfile(userProfileUpdateFields: Array<UserProfileUpdateField>) {
    return this.userService.updateUserProfile(userProfileUpdateFields).toPromise();
  }
}
